import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { SharedExternalCMRAgentActionsComponent } from '../../actions/shared.external.cmr.agent.actions.component';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { OpenRouteCMRController } from '@shared/src/controllers/open/openroutecmr.controller';
import { RouteCMRAgents } from '@shared/src/controllers/route/cmr/RouteCMRAgents';
import { RouteCMRAgentDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentDto';
import { RouteCMRAgentPhaseDto } from '@shared/src/dtos/route/cmr/agent/RouteCMRAgentPhaseDto';
import { HString, SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent } from '@shared/src/public-api';
import { Location } from '@angular/common';

@Component({
    selector: 'shared-external-cmr-agent-driver-qr-page',
    templateUrl: './shared.external.cmr.agent.driver.qr.page.html',
    styleUrls: ['../shared.external.cmr.agent.qr.page.scss']
})
export class SharedExternalCMRAgentDriverQRPage implements OnInit {


    public allLoaded: boolean = false;
    public useIonic: boolean = false;
    constructor(public router: Router, protected activatedRoute: ActivatedRoute,
        public location: Location,
        @Inject('HomeController') protected homeController: HomeController,
        public openRouteCMRController: OpenRouteCMRController) {

        if (homeController.useIonic)
            this.useIonic = homeController.useIonic();

        	//Fem subscribe per detectar només el location.back i location.forward que s'executen  només al anar endevant i enrera en els botons del navegador
		//Nomes ho fem amb aquests dos casos ja que o sinó esta constantment detectant canvis al canviar els parametres de url en el routeTo
		this.location.subscribe(
			((value: PopStateEvent) => {
				console.log(value);
				this.loadParametersLocation();
			}),
			(ex => {
				console.log("Error occured postate event")
				console.log(ex);
			})
		);
    }

    ngOnInit(): void {
    
        this.loadParameters();

        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                this.loadParametersLocation();
            }
        });

    }

    public loadParameters(){
        this.activatedRoute.params.subscribe(a => {
            this.uuidQR = a.uuidQR;
            this.loadParametersLocation();   
        });
    }
    
	public static PARAMETEROPTIONNAME = "option";
	public static PARAMETERPHASEUUIDNAME = "phaseUUID";

    public loadParametersLocation() {

        let path = this.location.path();
        if (path == "")
            return;
    
        let tree = this.router.parseUrl(path);
        let queryParams = tree.queryParams;
    
        let phaseUUID = queryParams[SharedExternalCMRAgentDriverQRPage.PARAMETERPHASEUUIDNAME];
        if(phaseUUID)
            this.phaseUUID = phaseUUID;

        let option = queryParams[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME];
        if (option)
            this.welcomeOptionExpanded(option);
                
        this.allLoaded = true;
       
    }
    
    routeTo() {
        if (!this.allLoaded || this.useIonic)
          return;
    
        if (!HString.startsWith(this.router.url, "/external/cmr/qr"))
          return;
    
        let object = { ...this.activatedRoute.snapshot.queryParams };
        if (!HString.isNullOrNullString(this.optionExpanded))
          object[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME] = this.optionExpanded;
        else
          delete object[SharedExternalCMRAgentDriverQRPage.PARAMETEROPTIONNAME];
    
        if (!HString.isNullOrNullString(this.phaseUUID))
          object[SharedExternalCMRAgentDriverQRPage.PARAMETERPHASEUUIDNAME] = this.phaseUUID;
        else
          delete object[SharedExternalCMRAgentDriverQRPage.PARAMETERPHASEUUIDNAME];
    
        //Aqui no estem rederigint, només estem actualtzant els queryParams perque es vegi reflectida la URL. 
        //Al no redirigir (que ja es el que volem perquè no es necessàri), no està refrescant la pagina i no entrarà pel ngOnInit()
        this.router.navigate([".", {}], { relativeTo: this.activatedRoute, queryParams: object, queryParamsHandling: '' });
    }

    public optionExpanded: string = "";
    public welcomeOptionExpanded(option: string){
        this.optionExpanded = option;
        this.showButtonBack = !HString.isNullOrNullString(option);
        this.routeTo();
    }
    onClickLinkOption(option: string) {

        if (option == this.optionExpanded) {
            return;
        }
        
        this.welcomeOptionExpanded(option);
    }

    goTo(option: string) {
        this.optionExpanded = option;
        this.routeTo();
    }

    @ViewChild(SharedExternalCMRAgentActionsComponent) actionsComponent: SharedExternalCMRAgentActionsComponent;
    @ViewChild(SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent) phaseComponent: SharedExternalCMRAgentPhaseECMRsDigitalDocumentComponent;
 
    onClickBack(){
        if (this.optionExpanded === 'Actions' && this.actionsComponent?.collapse())
            return;
        if(this.optionExpanded == 'Phase' && this.phaseComponent?.collapse())
            return true;
        this.goToNormal();
    }

    public loadingToNormal: boolean;
    goToNormal() {
        if (this.loadingToNormal)
            return;
        this.loadingToNormal = true;
        this.openRouteCMRController.getRouteCMRAgentByUUID(this.uuidQR, RouteCMRAgents.driver).subscribe(data => { 
            this.loadingToNormal = false;
            this.value = Object.assign({}, data);
            this.phaseUUID = "";
            this.optionExpanded = '';
            this.showButtonBack = false;
            this.routeTo();
        });
    }

    public showButtonBack: boolean = false;

    public __uuidQR: string = "";
    public set uuidQR(value: string) {
        if (this.__uuidQR === value)
            return;
        this.__uuidQR = value;
        this.getData();
    }
    public get uuidQR(): string {
        return this.__uuidQR;
    }

    public __value: RouteCMRAgentDto;
    public set value(value: RouteCMRAgentDto) {
        if (this.__value === value)
            return;
        this.__value = value;
    }
    public get value(): RouteCMRAgentDto {
        return this.__value;
    }

    public __phaseUUID: string;
    public set phaseUUID(value: string) {
        if (this.__phaseUUID === value)
            return;
        this.__phaseUUID = value;
        this.refreshPhaseSelected();
    }
    public get phaseUUID(): string {
        return this.__phaseUUID;
    }
    
    public refreshPhaseSelected(){
        if (this.phaseUUID && this.value != null && this.value.phases != null) {
            let i = 0;
            for (i = 0; i < this.value.phases.length; i++)
            if (this.value.phases[i].uuid == this.phaseUUID)
                if (this.optionExpanded == "Phase")
                    this.goToPhase(this.value.phases[i]);
        }
    }

    public getData() {
        if (!HString.isNullOrNullString(this.uuidQR)) {
            this.openRouteCMRController.getRouteCMRAgentByUUID(this.uuidQR, RouteCMRAgents.driver).subscribe(data => { 
                this.value = data;
                this.refreshPhaseSelected();
            });
        }    
    }

    public getCount():number{
        if(this.value == null)
            return 0;
        return this.value.countRouteParts;
    }

    public goToPhase(phase: RouteCMRAgentPhaseDto){
        this.phaseUUID = phase != null ? phase.uuid : "";
        if(!HString.isNullOrNullString(this.phaseUUID)){
            this.onClickLinkOption('Phase');
        }
    }

    public getResourcePhase(phase: RouteCMRAgentPhaseDto): string{
        if(phase == null || phase.isLoad)
            return 'SHARED.EXTERNAL.CMR.PHASE.ISLOAD';
        return 'SHARED.EXTERNAL.CMR.PHASE.ISUNLOAD';
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }

}
